class DeviceService {
    static getOrientation(): string {
        const isSafari: boolean = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        let orientation: string;

        if (isSafari) {
            orientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
        } else {

            if (process.env.APP_ENV === 'local') {
                orientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
            } else {
                orientation = screen.orientation.type.match(/\w+/)[0];
            }
        }
        return orientation;
    }
}

export default DeviceService;
